import { Button, Card, Flex, Form, Spin } from 'antd';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// components
import CommitteeSettings from '../components/committeeSettings';
import ComponentHeader from 'components/componentHeader/componentHeader';

// services
import { onCreateCommittee } from '../services/committeeServices';
import NotificationService from 'core/services/notification';

// models
import { CreateCommitteePayload } from '../models/committee';
import Icon from 'utils/icon';
import { isRTL } from 'core/services/language';

const CommitteeCreatePage: FunctionComponent = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const [loading, setLoading] = useState<boolean>(false);

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);

			const payload: CreateCommitteePayload = {
				...values,
				name: {
					ar: values['name[ar]'],
					en: values['name[en]'],
				},
			};

			await onCreateCommittee(payload);
			NotificationService.success(t('ACTIONS.COMMITTEE_CREATED_SUCCESSFULLY'));
			navigate('/dashboard/actions/boards/committees');
			setLoading(false);
		} catch (error: any) {
			NotificationService.error(error);
			setLoading(false);
		}
	};

	return (
		<Card>
			<Flex justify="space-between" gap={30} wrap className='mb-4'>
				<ComponentHeader title={t('ACTIONS.NEW_COMMITTEE_FORMATION')} subtitle={t('ACTIONS.FILL_TO_APPOINT_COMMITTEE')} />

				<Icon name="registrationStep1" width={280} height={50} style={{ transform: isRTL() ? 'rotateY(180deg)' : 'none' }} />
			</Flex>

			<Form
				form={form}
				layout="vertical"
				onFinish={handleSubmit}
				initialValues={{ minimum_quorum_percentage: 50, minimum_notification_days_before_meetings: 1 }}>
				<CommitteeSettings form={form} />

				<Flex justify="end" className="mt-4">
					<Button type="primary" htmlType="submit" loading={loading}>
						{t('COMMON.CREATE')}
					</Button>
				</Flex>
			</Form>
		</Card>
	);
};

export default CommitteeCreatePage;
